import { inject } from "vue";
const key = "__CURRENT_APP_INSTANCE__"
export const currentAppInstancePlugin = {
    install: (app, options) => {
        app.provide(key, app)
    }
}

export function useCurrentAppInstance() {
    return inject(key);
}